import React from "react";
import { Link } from "react-router-dom";

import gyozaMenu from "../../../assets/images/resource/menu-image-5.webp";
import yakinukuMenu from "../../../assets/images/resource/menu-image-6.webp";
import butaBaraMenu from "../../../assets/images/resource/menu-image-7.webp";
import toriKaraage from "../../../assets/images/resource/menu-image-8.webp";
import chickenBumpMenu from "../../../assets/images/resource/menu-image-10.webp";

function Meat() {
  return (
    <>
      <section className="menu-two">
        <div className="auto-container">
          <div className="title-box centered">
            <h2>Meat</h2>
          </div>
          <div className="row clearfix">
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={gyozaMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Gyoza <span className="s-info">5 PCS.</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$14.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">Homemade pan-fried pork dumplings</Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={yakinukuMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Yakiniku</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$16.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">Marinated beef in hot plate</Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={butaBaraMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Buta Bara Kushi{" "}
                            <span className="s-info">6 PCS.</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$13.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Grilled marinated pork belly with Scallion
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={toriKaraage} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Tori Karaage <span className="s-info">5 PCS.</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$14.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Japanese style marinated crispy chicken with 3 homemade
                        sauces (spicy mayo/ wasabi mayo/ ponzu)
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="dish-block">
                  <div className="inner-box">
                    <div className="dish-image">
                      <Link to="#">
                        <img src={chickenBumpMenu} alt="" />
                      </Link>
                    </div>
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Chicken Bumps</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$12.00</span>
                      </div>
                    </div>
                    <div className="text desc">
                      <Link to="#">
                        Crispy chicken skin mixed with homemade seasonings
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Meat;
